import { createReducer, on } from '@ngrx/store';
import {
    PlayerNotification,
    PlayerNotificationsResponse,
} from '../../../profile/models/currentPlayer.interface';
import { ProfileNotificationsActions } from '../actions/actions-type.action';

export interface ProfileNotificationsState {
    notifications: PlayerNotificationsResponse;
    isLoading: boolean;
}

const initialState: ProfileNotificationsState = {
    notifications: {
        items: [],
        page: 0,
        pageSize: 0,
        itemsCount: 0,
        total: 0,
    },
    isLoading: false,
};

export const profileNotificationsReducer = createReducer(
    initialState,
    on(ProfileNotificationsActions.fetchPlayerNotifications, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        ProfileNotificationsActions.fetchPlayerNotificationsSuccess,
        (state, action) => ({
            ...state,
            notifications: {
                items: action.payload.patchData
                    ? action.payload.response.items
                    : [
                          ...state.notifications.items,
                          ...action.payload.response.items,
                      ],
                page: action.payload.response.page,
                pageSize: action.payload.response.pageSize,
                itemsCount: action.payload.response.itemsCount,
                total: action.payload.response.total,
            },
            isLoading: false,
        })
    ),
    on(
        ProfileNotificationsActions.postNewProfileNotification,
        (state, action) => {
            const isNotExist = !state.notifications.items.some(
                (n) => n.id === action.payload.id
            );

            if (isNotExist) {
                return {
                    ...state,
                    notifications: {
                        ...state.notifications,
                        items: [action.payload, ...state.notifications.items],
                    },
                };
            } else {
                return {
                    ...state,
                };
            }
        }
    ),
    on(
        ProfileNotificationsActions.fetchPlayerNotificationsFailure,
        (state, action) => ({
            ...state,
            error: action.payload,
            isLoading: false,
        })
    ),
    on(ProfileNotificationsActions.markAsReadNotification, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        ProfileNotificationsActions.markAsReadNotificationSuccess,
        (state, action) => ({
            ...state,
            notifications: {
                ...state.notifications,
                items: state.notifications.items.map(
                    (i): PlayerNotification =>
                        action.payload.notificationIds.includes(i.id)
                            ? { ...i, isRead: true }
                            : i
                ),
            },
            isLoading: false,
        })
    ),
    on(
        ProfileNotificationsActions.markAsReadNotificationFailure,
        (state, action) => ({
            ...state,
            error: action.payload,
            isLoading: false,
        })
    ),
    on(ProfileNotificationsActions.deleteNotification, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        ProfileNotificationsActions.updateInvitationNotificationStatusSuccess,
        ProfileNotificationsActions.deleteNotificationSuccess,
        (state, action) => ({
            ...state,
            notifications: {
                ...state.notifications,
                items: state.notifications.items.filter(
                    (i) => i.id !== action.payload.id
                ),
            },
            isLoading: false,
        })
    ),
    on(
        ProfileNotificationsActions.deleteNotificationFailure,
        (state, action) => ({
            ...state,
            error: action.payload,
            isLoading: false,
        })
    ),
    on(
        ProfileNotificationsActions.updateInvitationNotificationStatus,
        (state) => ({
            ...state,
            isLoading: true,
        })
    ),
    on(
        ProfileNotificationsActions.updateInvitationNotificationStatusSuccess,
        (state) => ({
            ...state,
            isLoading: false,
        })
    ),
    on(
        ProfileNotificationsActions.updateInvitationNotificationStatusFailure,
        (state, action) => ({
            ...state,
            error: action.payload,
            isLoading: false,
        })
    ),
    on(ProfileNotificationsActions.clearProfileNotificationsList, (state) => ({
        ...state,
        items: [],
    }))
);
